import { Component,OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { formControl } from '@app/helpers/form-control.helpers';
import { BaseModalDirective } from '../base-modal';
import Vs from '@app/services/validators/validators.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ServiceConfigService } from '@app/services/service-config.service';
import { ApplicationService } from '@app/services/application/application.service';
import { StateService } from '@app/services/state/state.service';
import { StorageService } from '@app/services/storage/storage.service';
declare let gtag: Function;

@Component({
    selector: 'nh-apu-routing-modal',
    templateUrl: './apu-routing-modal.component.html',
    styleUrls: ['./apu-routing-modal.component.scss'],
    standalone: false
})
export class ApuRoutingModalComponent extends BaseModalDirective implements OnInit {
  commentsControl: FormControl;
  translatedLang:any;
  defaultLanguage:any;
  medicalAppealsSwitch: boolean = false;
  applicationNum: any;
  constructor(protected modalRef: BsModalRef,protected builder: FormBuilder,public translateService: TranslateService,private router: Router, private serverConfig: ServiceConfigService,
      private application: ApplicationService,
      private storageService: StorageService,
      private stateService: StateService
  ) {
    super(modalRef, builder);
  }

 
  ngOnInit() {
    this.medicalAppealsSwitch = this.serverConfig.getServerConfig()?.medicalAppealsSwitch;
    this.commentsControl = formControl(this.body, Vs.comments);
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {     
      this.defaultLanguage = res.lang
      this.translatedLang = this.defaultLanguage;          
    });
  }

  onStart(): void {
    this.hide('');    
  }

  onCancel(): void{   
    this.hide('');
  }
  
  uploadProof() {  
    this.onCancel();
    this.router.navigate(['user-profile/my-documents', 'documents-we-need'])
  }
  appealPetitonForm() {  
    this.onCancel();    
    this.router.navigateByUrl("/user-profile/appeal-petition-submission");
  }
  onClosePopup(): void {
    this.onCancel();
    this.router.navigateByUrl("/user-profile/benefit-dashboard");
  }

  onSelectReturnToAppeal(): void {
    this.onCancel();
  }

  
  fileMedicalAppeal(appType: string) {
    this.hide('');
    this.application.getHeadOfHouseholdInfo(0, 'MEDICAL_APPEAL', 'MEDICAL_APPEAL').subscribe((res: any) => {
      gtag('event', 'medical_appeal_from_appeals', {
        'event_category': 'medical_appeal_from_appeals',
        'event_label': 'medical_appeal_from_appeals',
      });
      this.applicationNum = res?.applicationNumber;
      if (this.applicationNum && this.storageService.getAppNumber() !== this.applicationNum) {
        sessionStorage.setItem('appNum', this.applicationNum);
        this.storageService.setAppNumber(this.applicationNum);
      }
      if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
        this.stateService.resetStates();
        this.application.deleteApp(this.applicationNum, 'TCMAP').subscribe(() => {
          sessionStorage.setItem('appNum', null);
          this.storageService.setApplicationType(appType);
          this.router.navigateByUrl('/application/' + 'NEW');
        })
      }
      else {
        this.stateService.resetStates();
        sessionStorage.setItem('appNum', null);
        this.storageService.setApplicationType(appType);
        this.router.navigateByUrl('/application/' + 'NEW');
      }
    });
  }
}